import { call, put, takeEvery, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { getAddressFormat } from './api';
import {
  GET_ADDRESS_FORMAT_REQUEST,
  GET_ADDRESS_FORMAT_OBJECT_REQUESTING,
  GET_ADDRESS_FORMAT_SUCCESS
} from './constants';

const countryCodesLoading = [];

function* get(action) {
  try {
    if (!countryCodesLoading.includes(action.countryCode)) {
      countryCodesLoading.push(action.countryCode);
      yield call(removeAPIError);
      yield put({ type: GET_ADDRESS_FORMAT_OBJECT_REQUESTING });
      const response = yield call(getAddressFormat, action.countryCode);
      yield put({ type: GET_ADDRESS_FORMAT_SUCCESS, payload: response.data });
    }
  } catch (error) {
    yield call(addAPIError, error);
  }
}

export function* setAddressFormat(action) {
  yield put({
    type: GET_ADDRESS_FORMAT_SUCCESS,
    payload: action.addressFormat
  });
}

function* watchList() {
  yield takeEvery(GET_ADDRESS_FORMAT_REQUEST, get);
}

export default function* addressFormatSagas() {
  yield all([watchList()]);
}
